import type { SxProps, Theme } from '@mui/material';

const getArrowColor = (theme: Theme, canDrop: boolean, isOver: boolean) => {
  if (canDrop) {
    if (isOver) {
      return {
        borderColor: `${theme.colors.green[600]} transparent transparent transparent`,
      };
    }
    return {
      borderColor: `${theme.colors.neutral[500]} transparent transparent transparent`,
    };
  }
  return {
    borderColor: `${theme.colors.neutral[400]} transparent transparent transparent`,
  };
};

export const styles = {
  dropDownTarget: {
    minHeight: '100px',
    width: '12.5rem',
    marginBottom: '20px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    fontSize: 13,
  } as SxProps<Theme>,

  title: (theme: Theme) => ({
    maxWidth: '12.5rem',
    backgroundColor: theme.colors.neutral[200],
    padding: 0.5,
    marginBottom: 0.5,
  }),

  arrow:
    (canDrop: boolean, isOver: boolean): SxProps<Theme> =>
    (theme: Theme) => ({
      maxWidth: '12.5rem',
      position: 'relative',
      color: theme.colors.white,
      height: '2rem',
      boxSizing: 'border-box',
      paddingTop: 0.5,

      '&::after': {
        position: 'absolute',
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: -1,
        content: '""',
        display: 'block',
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '2rem calc(12.5rem / 2) 0 calc(12.5rem / 2)',
        ...getArrowColor(theme, canDrop, isOver),
      },
    }),
};
